import { useTranslation } from "react-i18next";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import FunctionalButton from "components/layout/FunctionalButton";

interface DockingRequiredConfirmDialogProps {
    visible: boolean;
    onConfirm: () => void;
    onDecline: () => void;
}

/**
 * Asked when the user taps Docking during mission creation.
 * Yes → undock before start Load Map + dock at mission end.
 */
export const DockingRequiredConfirmDialog: React.FC<DockingRequiredConfirmDialogProps> = ({
    visible,
    onConfirm,
    onDecline,
}) => {
    const { t } = useTranslation(["missions", "common"]);

    return (
        <AnimatedModal
            visible={visible}
            onClose={onDecline}
            closeOnBackdrop={false}
            className="max-w-md rounded-r10 bg-black100 p-6"
        >
            <h2 className="mb-3 text-h4 font-semibold">{t("dialogs.dockingRequiredTitle")}</h2>
            <p className="mb-6 text-h5 text-black40">{t("dialogs.dockingRequiredBody")}</p>
            <div className="flex justify-end gap-3">
                <FunctionalButton
                    title={t("common:no")}
                    className="bg-black70 px-4 py-2"
                    onClick={onDecline}
                />
                <FunctionalButton title={t("common:yes")} className="px-4 py-2" onClick={onConfirm} />
            </div>
        </AnimatedModal>
    );
};

/** @deprecated Prefer DockingRequiredConfirmDialog */
export const DockingUndockConfirmDialog = DockingRequiredConfirmDialog;
